import React, { useState, useContext } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import FormatAlignJustifyIcon from "@mui/icons-material/FormatAlignJustify";
import {
  Divider,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Backdrop,
  CircularProgress,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import BasicAccordion from "./BasicAccordion";
import SaveIcon from "@mui/icons-material/Save";
import { useDispatch, useSelector } from "react-redux";
import {
  setState,
  getProductGroupForMS,
  MarketShareComparison,
  getBrandsForCountry,
} from "../scenarioSetupNewSlice";
import { sizes } from "../scenarioSetupNewUtils";
import AutoCompleteMS from "./AutoCompleteMS";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { DownloadOutlined } from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { Paper } from "@mui/material";
import Chart from "react-apexcharts";
import "./ScenarioCreate.css";
import { orderBy } from "lodash";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import { useEffect } from "react";
import MultiSelectSKU from "./MultiSelectSKU";
import MultiSelectBrand from "./MultiSelectBrand";
import CustomButton from "../../../../components/ui/CustomButton";


const SW = sizes.w250;
const LW = sizes.w650;
const commonHeight = sizes.h35;
const headers = [
  { id: "name", label: "Customers" },
  { id: "scenarioSKU_Volume", label: "Volume" },
  { id: "scenarioSKU_MS", label: "MS%" },
  { id: "external_Fix_MS", label: "MS%" },
  { id: "referenceSKU_Volume", label: "Volume" },
  { id: "referenceSKU_MS", label: "MS%" },
  { id: "external_MS", label: "MS%" },
  { id: "manually_Defined_MS", label: "MS%" },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1200,
  height: 800,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  "max-height": "100%",
};

export default function MarketShareComparisonModal() {

  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  const [popupData, setPopupData] = useState(null);
  const [isData, setIsData] = useState(false);

  const {
    selectedPGs,
    isLoading,
    selectedCustsCGs,
    CBDMPeriod,
    selectedReferenceSKU,
    customerBreakdown,
    MarketShareTimePeriod,
    countryID,
    marketShareComparisonList,
    selectedRows,
    marketShareGraphData,
    drawerOpen,
    legends,
    previousSelectedReferenceSKU,
    previousMarketShareComparisonList,
    previousMarketShareGraphData,
    manually_defineMSList,
    scenarioExternalDataSource,
    PreviousMarketShareTimePeriod,
    productGroupsForMS,
    createFromDate,
    customerBreakdownType,
    isCustomerChanged,
    selectedBrandsByCountry,
    previousSelectedBrands,
    brandsByCountry,
    editScDetails,
    refList,
  } = useSelector((store) => store.scenarioSetupNew);
  //const { , statuses } = marketShareGraphData;
  const dispatch = useDispatch();
  //dispatch(setState("legends", ['Scenario SKU','Reference SKU','External','Manually Defined']))
  function getSeries() {
    let series = [];
    for (let prop in marketShareGraphData) {
      const obj = {
        name: prop,
        data: marketShareGraphData[prop],
      };
      series.push(obj);
    }
    return series;
  }
  const series = getSeries();
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [orderByColumn, setOrderByColumn] = useState('');
  const [order, setOrder] = useState('asc');
  const [openPopup, setOpenPopup] = useState(false);
  const [name, setName] = useState("");

  //Get previous selected Brands on Modal Open
   useEffect(() => {
    if (editScDetails?.scenarioSelectedBrands) {
      const getBrandsData = editScDetails?.scenarioSelectedBrands.split('|,|');
      dispatch(setState("selectedBrandsByCountry", getBrandsData));
      dispatch(setState("previousSelectedBrands", getBrandsData));
    }
  }, [editScDetails, dispatch]);

  console.log(productGroupsForMS);
  // Handle legend click
  useEffect(() => {
    if (scenarioExternalDataSource != undefined && scenarioExternalDataSource != null && scenarioExternalDataSource.length > 0) {
      let MSShare = JSON.parse(JSON.stringify(marketShareComparisonList));
      for (let i = 0; i < marketShareComparisonList.length; i++) {
        let res = scenarioExternalDataSource.find(p => p['customerID'] == marketShareComparisonList[i].id || p['customerGroupID'] == marketShareComparisonList[i].id);
        if (res != undefined) {
          MSShare[i].external_MS = res.share * 100;
        }
      }
      dispatch(setState("marketShareComparisonList", MSShare));
      dispatch(setState("previousMarketShareComparisonList", MSShare));
    }

  }, [scenarioExternalDataSource]);
  useEffect(() => {
    if (MarketShareTimePeriod === undefined || MarketShareTimePeriod === "") {
      dispatch(setState("MarketShareTimePeriod", customerBreakdown));
      dispatch(setState("PreviousMarketShareTimePeriod", customerBreakdown));
    }
  })
  const preparemarketShareGraphData = () => {
    let data = JSON.parse(JSON.stringify(marketShareComparisonList));
    let sortedArrayScenarioSKU = orderBy(data, ["scenarioSKU_MS"], ["desc"]);
    let sortedArrayReferenceSKU = orderBy(data, ["referenceSKU_MS"], ["desc"]);
    let sortedArrayExternal = orderBy(data, ["external_MS"], ["desc"]);
    let sortedArrayManual = orderBy(data, [(item) => parseInt(item.manually_Defined_MS)], ["desc"]);
    let Count = 0
    let Ids = [];
    for (Count; Count < sortedArrayScenarioSKU.length; Count++) {
      if (sortedArrayScenarioSKU[Count].scenarioSKU_MS == 0) break;
      Ids.push(sortedArrayScenarioSKU[Count].id);
      if (Count === 100) break;
    }
    if (Count < 100) {
      for (let i = 0; i < sortedArrayReferenceSKU.length; i++) {
        if (sortedArrayReferenceSKU[i].referenceSKU_MS == 0) break;
        let idx = Ids.findIndex(p => p == sortedArrayReferenceSKU[i].id);
        if (idx == -1) {
          Count += 1;
          Ids.push(sortedArrayReferenceSKU[i].id);
          if (Count === 100) break;
        }
      }
    }
    if (Count < 100) {
      for (let i = 0; i < sortedArrayExternal.length; i++) {
        if (sortedArrayExternal[i].external_MS == 0) break;
        let idx = Ids.findIndex(p => p == sortedArrayExternal[i].id);
        if (idx == -1) {
          Count += 1;
          Ids.push(sortedArrayExternal[i].id);
          if (Count === 100) break;
        }
      }
    }
    if (Count < 100) {
      for (let i = 0; i < sortedArrayManual.length; i++) {
        if (sortedArrayManual[i].manually_Defined_MS == 0) break;
        let idx = Ids.findIndex(p => p == sortedArrayManual[i].id);
        if (idx == -1) {
          Count += 1;
          Ids.push(sortedArrayManual[i].id);
          if (Count === 100) break;
        }
      }
    }
    // if(j > 100) j= 100; //setting max limit to 100 customers
    const filteredData = data.filter((x) => Ids.includes(x.id));
    let entities = [...new Set(filteredData.map((obj) => obj.name))];
    let legends = ['Scenario SKU', 'Reference SKU', 'External', 'Manually Defined'];

    let statuses = {};
    for (let i = 0; i < entities.length; ++i) {
      statuses[entities[i]] = new Array(legends.length).fill(0);
      //if(i == j) break;
    }

    for (let i = 0; i < filteredData.length; ++i) {
      const obj = filteredData[i];
      const { name } = obj;
      statuses[name][0] = obj.scenarioSKU_MS;
      statuses[name][1] = obj.referenceSKU_MS;
      statuses[name][2] = obj.external_MS;
      statuses[name][3] = obj.manually_Defined_MS;
      //if(i == j) break;
    }
    const preparedData = statuses;
    dispatch(setState("marketShareGraphData", preparedData));
  }
  const preparemarketShareGraphDataForPrevious = () => {
    let data = JSON.parse(JSON.stringify(marketShareComparisonList));
    let sortedArrayScenarioSKU = orderBy(data, ["scenarioSKU_MS"], ["desc"]);
    let sortedArrayReferenceSKU = orderBy(data, ["referenceSKU_MS"], ["desc"]);
    let sortedArrayExternal = orderBy(data, ["external_MS"], ["desc"]);
    let sortedArrayManual = orderBy(data, [(item) => parseInt(item.manually_Defined_MS)], ["desc"]);
    let Count = 0
    let Ids = [];
    for (Count; Count < sortedArrayScenarioSKU.length; Count++) {
      if (sortedArrayScenarioSKU[Count].scenarioSKU_MS == 0) break;
      Ids.push(sortedArrayScenarioSKU[Count].id);
      if (Count === 100) break;
    }
    if (Count < 100) {
      for (let i = 0; i < sortedArrayReferenceSKU.length; i++) {
        if (sortedArrayReferenceSKU[i].referenceSKU_MS == 0) break;
        let idx = Ids.findIndex(p => p == sortedArrayReferenceSKU[i].id);
        if (idx == -1) {
          Count += 1;
          Ids.push(sortedArrayReferenceSKU[i].id);
          if (Count === 100) break;
        }
      }
    }
    if (Count < 100) {
      for (let i = 0; i < sortedArrayExternal.length; i++) {
        if (sortedArrayExternal[i].external_MS == 0) break;
        let idx = Ids.findIndex(p => p == sortedArrayExternal[i].id);
        if (idx == -1) {
          Count += 1;
          Ids.push(sortedArrayExternal[i].id);
          if (Count === 100) break;
        }
      }
    }
    if (Count < 100) {
      for (let i = 0; i < sortedArrayManual.length; i++) {
        if (sortedArrayManual[i].manually_Defined_MS == 0) break;
        let idx = Ids.findIndex(p => p == sortedArrayManual[i].id);
        if (idx == -1) {
          Count += 1;
          Ids.push(sortedArrayManual[i].id);
          if (Count === 100) break;
        }
      }
    }
    // if(j > 100) j= 100; //setting max limit to 100 customers
    const filteredData = data.filter((x) => Ids.includes(x.id));
    let entities = [...new Set(filteredData.map((obj) => obj.name))];
    let legends = ['Scenario SKU', 'Reference SKU', 'External', 'Manually Defined'];

    let statuses = {};
    for (let i = 0; i < entities.length; ++i) {
      statuses[entities[i]] = new Array(legends.length).fill(0);
      //if(i == j) break;
    }

    for (let i = 0; i < filteredData.length; ++i) {
      const obj = filteredData[i];
      const { name } = obj;
      statuses[name][0] = obj.scenarioSKU_MS;
      statuses[name][1] = obj.referenceSKU_MS;
      statuses[name][2] = obj.external_MS;
      statuses[name][3] = obj.manually_Defined_MS;
      //if(i == j) break;
    }
    const preparedData = statuses;
    dispatch(setState("previousMarketShareGraphData", preparedData));
  }
  useEffect(() => {
    preparemarketShareGraphData();
  }, [marketShareComparisonList]);
  useEffect(() => {
    preparemarketShareGraphDataForPrevious();
  }, [previousMarketShareComparisonList]);
  const handleLegendClick = (_, seriesIndex) => {
    if (seriesIndex !== undefined) {
      const clickedSeriesData = series[seriesIndex];
      setPopupData(clickedSeriesData);
      setOpenPopup(true);
      setName(clickedSeriesData.name);
    }
  };
  const handleBarClick = (_, seriesIndex, dataPointIndex) => {
    if (dataPointIndex.seriesIndex !== undefined) {
      const clickedSeriesData = series[dataPointIndex.seriesIndex];
      setPopupData(clickedSeriesData);
      setOpenPopup(true);
      setName(clickedSeriesData.name);
    }

  };
  const handleClosePopup = () => {
    setOpenPopup(false);
  }
  const handleRequestSort = (columnId) => {
    const isAsc = orderByColumn === columnId && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderByColumn(columnId);
  };

  const sortedRows = orderBy(
    marketShareComparisonList,
    orderByColumn,
    order
  ).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const selectColumn = [
    {
      field: "name",
      headerName: "Customers",
      hideSortIcons: true,
      width: 300,
      height: 50,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "scenarioSKU_Volume",
      headerName: "Scenario SKU",
      hideSortIcons: true,
      renderCell: (params) => (
        <table>
          <tbody>
            <tr>
              <td
                style={{
                  border: "1x solid black",
                  width: "100px",
                  textAlign: "center",
                }}
              >
                {params.row.scenarioSKU_Volume}
              </td>
              <td
                style={{
                  border: "1x solid black",
                  width: "100px",
                  textAlign: "center",
                }}
              >
                {params.row.scenarioSKU_MS}
              </td>
            </tr>
          </tbody>
        </table>
      ),
      width: 200,
      height: 50,
      align: "center",
      headerAlign: "center",
      // filterOperators: stringOperators,
    },
    {
      field: "external_Fix_MS",
      headerName: "External Fix",
      hideSortIcons: true,
      width: 100,
      height: 50,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "referenceSKU_Volume",
      headerName: "Domestic ref SKU (Selected SKU)",
      hideSortIcons: "false",
      renderCell: (params) => (
        <table>
          <tbody>
            <tr>
              <td
                style={{
                  border: "1x solid black",
                  width: "100px",
                  textAlign: "center",
                }}
              >
                {params.row.referenceSKU_Volume}
              </td>
              <td
                style={{
                  border: "1x solid black",
                  width: "100px",
                  textAlign: "center",
                }}
              >
                {params.row.referenceSKU_MS}
              </td>
            </tr>
          </tbody>
        </table>
      ),
      width: 200,
      height: 50,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "external_MS",
      headerName: "External WHS MS(if any)",
      hideSortIcons: true,
      width: 150,
      height: 50,
      align: "center",
      headerAlign: "center",
    },
    {
      field: "manually_Defined_MS",
      headerName: "Manually Defined (optional)",
      disableColumnMenu: true,
      hideSortIcons: true,
      filterable: false,
      width: 150,
      height: 50,
      align: "center",
      headerAlign: "center",
      renderCell: (params) =>
        params.row.id > 0 && (
          <table>
            <tbody>
              <tr>
                <input
                  type="number"
                  OnlyNumber
                  decimals="5"
                  onChange={updateManuallyDefined(params)}
                  class="form-control form-control-sm"
                  style={{ width: "80px", height: "40px", textAlign: "center" }}
                  value={params.row.manually_Defined_MS}
                />
              </tr>
            </tbody>
          </table>
        ),
    },
  ];
  const updateManuallyDefined = (row) => (e) => {
    const { value } = e.target;
    if (isNaN(value) || value >= 0) {
      const id = row.id;
      const MS = JSON.parse(JSON.stringify(marketShareComparisonList));
      let idx = MS.findIndex((x) => x.id === id);
      if (idx !== -1) {
        MS[idx].manually_Defined_MS = Math.floor(parseFloat(value) * 10) / 10;
        dispatch(setState("marketShareComparisonList", MS));
      }
    }
  };
  const options = {
    chart: {
      type: "bar",
      height: 430,
      stacked: true,
      events: {
        legendClick: handleLegendClick,
        dataPointSelection: handleBarClick,
      },
    },
    title: {
      text: "Market Share Comparison",
      align: "left",
      margin: 20,
      offsetX: 0,
      offsetY: 0,
      floating: true,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#263238",
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: false,
      offsetX: -6,
      style: {
        fontSize: "12px",
        colors: ["#fff"],
      },
    },
    stroke: {
      show: true,
      width: 1,
      colors: ["#fff"],
    },
    tooltip: {
      shared: false,
      intersect: true,
    },
    xaxis: {
      categories: [...legends?.map((item) => item)],
    },
    yaxis: {
      min: 0,
      max: 100,
    },
    legend: {
      onItemClick: { toggleDataSeries: false },
    },
  };
  const optionsPopup = {
    chart: {
      type: "bar",
      height: 430,
      stacked: false,
    },
    title: {
      text: "",
      align: "left",
      margin: 20,
      offsetX: 0,
      offsetY: 0,
      floating: true,
      style: {
        fontSize: "14px",
        fontWeight: "bold",
        color: "#263238",
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: false,
      offsetX: -6,
      style: {
        fontSize: "12px",
        colors: ["#fff"],
      },
    },
    stroke: {
      show: true,
      width: 1,
      colors: ["#fff"],
    },
    tooltip: {
      y: {
        title: {
          formatter: function () {
            return "";
          },
        },
      },
    },
    xaxis: {
      categories: [...legends?.map((item) => item)],
    },
    legend: {
      onItemClick: { toggleDataSeries: false },
    },
  };
  const handleClose = () => {
    dispatch(setState("selectedReferenceSKU", previousSelectedReferenceSKU));
    dispatch(setState("selectedBrandsByCountry", previousSelectedBrands));
    dispatch(
      setState("marketShareComparisonList", previousMarketShareComparisonList)
    );
    if(previousSelectedReferenceSKU.length === 0){
      dispatch(setState("productGroupsForMS", []));
    }
    dispatch(setState("marketShareGraphData", previousMarketShareGraphData));
    dispatch(setState("MarketShareTimePeriod", PreviousMarketShareTimePeriod));
    setOpen(false);
    setIsData(false);
  };
  const handleSave = () => {
    let totalmanuallyDefined = marketShareComparisonList
      .reduce((a, b) => a + Number(b.manually_Defined_MS), 0)
      .toFixed(1);
    if (totalmanuallyDefined != 100 && totalmanuallyDefined != 0) {
      showMessage(
        "Please make sure the total manually defined percentage adds up to 100%",
        "error"
      );
    } else {
      dispatch(setState("previousSelectedReferenceSKU", selectedReferenceSKU));
      dispatch(setState("previousSelectedBrands", selectedBrandsByCountry));
      dispatch(
        setState("previousMarketShareComparisonList", marketShareComparisonList)
      );
      dispatch(setState("previousMarketShareGraphData", marketShareGraphData));
      let manually_define_MS_Sum = 0;
      let manually_define_MS_List = [];
      let mdList = {};
      for (let i = 0; i < marketShareComparisonList.length; i++) {
        mdList = {};
        manually_define_MS_Sum = marketShareComparisonList
          .reduce((a, b) => a + Number(b.manually_Defined_MS), 0)
          .toFixed(0);
        mdList.id = marketShareComparisonList[i].id;
        mdList.share = Number(marketShareComparisonList[i].manually_Defined_MS);
        mdList.name = marketShareComparisonList[i].name;
        mdList.type = marketShareComparisonList[i].type;
        manually_define_MS_List.push(mdList);
      }
      dispatch(setState("manually_defineMSList", manually_define_MS_List));
      if (customerBreakdownType === "Scenario SKUs" || customerBreakdownType === "Reference SKUs" || customerBreakdownType === "Dynamic Market Share") {
        dispatch(setState("customerBreakdown", MarketShareTimePeriod));
      }
      dispatch(
        setState("PreviousMarketShareTimePeriod", MarketShareTimePeriod)
      );
      dispatch(setState("refList", ""));
      setOpen(false);
    }
    dispatch(setState("isCustomerChanged", false));

    setIsData(false);
  };

  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  const handleStateUpdate = (event, stateName) => {
    const value = event.target.value;
    dispatch(setState(stateName, value));
    dispatch(setState("marketShareComparisonList", []));
    dispatch(setState("marketShareGraphData", []));
    setIsData(false);
  };

  const handleMSComparisonModalOpen = () => {
    if (selectedPGs.length <= 0) {
      showMessage("Please select at least one sku", "info");
      return;
    }
    if (selectedCustsCGs.length <= 0) {
      showMessage(
        "Please select at least one Customer or Customer group",
        "info"
      );
      return;
    }
    if (createFromDate == null || createFromDate == undefined || createFromDate == "") {
      showMessage("Please select the validity from date", "info");
      return;
    }
    let search = "";

    dispatch(getBrandsForCountry({ countryID }))
    // .then(() => {
    //   handleRetrieve();
    // });

    handleOpen();
  };
  const handleRetrieve = () => {
    // const selectedSKUList = selectedPGs
    //   .filter((x) => x.type == "P")
    //   .map((s) => s.id)
    //   .join(",");
    // const selectedPGList = selectedPGs
    //   .filter((x) => x.type == "PG")
    //   .map((s) => s.id)
    //   .join(",");
    // const referenceSKUList = selectedReferenceSKU
    // .filter((y) => y.id != 0)
    // .map((s) => s.id)
    // .join(",");
    // const customerList = selectedCustsCGs
    //   .filter((x) => x.type == "C")
    //   .map((s) => s.id)
    //   .join(",");
    // const customerGroupList = selectedCustsCGs
    //   .filter((x) => x.type == "CG")
    //   .map((s) => s.id)
    //   .join(",");

    const selectedSKUList = [];
    const selectedPGList = [];
    for (let i = 0; i < selectedPGs.length; i++) {
      if (selectedPGs[i].type === "PG") {
        selectedPGList.push(selectedPGs[i].id);
      } else if (selectedPGs[i].type === "P") {
        selectedSKUList.push(selectedPGs[i].id);
      } else if (selectedPGs[i].hasOwnProperty("productGroupID")) {
        selectedPGList.push(selectedPGs[i].productGroupID);
      } else if (selectedPGs[i].hasOwnProperty("productID")) {
        selectedSKUList.push(selectedPGs[i].productID);
      }
    }
    const customerList = [];
    const customerGroupList = [];
    for (let i = 0; i < selectedCustsCGs.length; i++) {
      if (selectedCustsCGs[i].type === "CG") {
        customerGroupList.push(selectedCustsCGs[i].id);
      } else if (selectedCustsCGs[i].type === "C") {
        customerList.push(selectedCustsCGs[i].id);
      } else if (selectedCustsCGs[i].hasOwnProperty("customerGroupID")) {
        customerGroupList.push(selectedCustsCGs[i].customerGroupID);
      } else if (selectedCustsCGs[i].hasOwnProperty("customerID")) {
        customerList.push(selectedCustsCGs[i].customerID);
      }
    }
    const selectedSKU = selectedSKUList.join(",");
    const selectedPG = selectedPGList.join(",");
    const selectedCustomer = customerList.join(",");
    const selectedCustomerGroup = customerGroupList.join(",");

    let referenceSKUList = "";
    if(selectedReferenceSKU !== undefined && selectedReferenceSKU.length > 0){
    referenceSKUList = selectedReferenceSKU
      .filter((y) => y.id != 0)
      .map((s) => s.id)
      .join(",");
    }
    else{
      referenceSKUList = refList;
    }

    let obj = {
      countryId: countryID,
      scenarioID: 0,
      timePeriod: MarketShareTimePeriod,
      selectedSKUList: selectedSKU,
      selectedPGList: selectedPG,
      referenceSKUList: referenceSKUList,
      customerList: selectedCustomer,
      customerGroupList: selectedCustomerGroup,
      startDate: changeDateFormat(createFromDate)
    };
    dispatch(MarketShareComparison(obj));

    setIsData(true);
    //dispatch(setState("previousSelectedReferenceSKU", selectedReferenceSKU));
  };
  const changeDateFormat = (date) => {
    const year = date.year();
    const month =
      date.month() + 1 < 10 ? `0${date.month() + 1}` : date.month() + 1;
    const day = date.date() < 10 ? `0${date.date()}` : date.date();
    const time = "T00:00:00.000Z";
    const d = `${year}-${month}-${day}${time}`;
    return d;
  };
  const pinnedRows = {
    top: [getRow(), getRow()],
    bottom: [getRow()],
  };

  function getRow() {
    return {
      id: 0,
    };
  }

  useEffect(() => {
    if(open){
      let pgBrandsObj = {
        countryId: countryID,
        brands: selectedBrandsByCountry
      }

      dispatch(getProductGroupForMS(pgBrandsObj));
      // .then(() => {
      //   handleRetrieve();
      // });
    }
  }, [selectedBrandsByCountry, countryID, open]);

  useEffect(() => {
    if(marketShareComparisonList?.length === 0 && isData === true){
      showMessage("No Data for the selected Criteria!","info");
    }
  },[marketShareComparisonList]);

  return (
    <Box>
      <CustomButton
        // startIcon={<FormatAlignJustifyIcon />}
        sx={{ mt: 2 }}
        // sx={{
        //   bgcolor: "darkred.light",
        //   color: "white.main",
        //   textTransform: "none",
        //   mt: 2,
        //   "&:hover": {
        //     bgcolor: "darkred.main",
        //   },
        // }}
        onClick={handleMSComparisonModalOpen}
      >
        Market Share Comparison
      </CustomButton>

      {isLoading ? (
        <Box>
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
          >
            <CircularProgress />
          </Backdrop>
        </Box>
      ) : (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ color: "darkred.main", fontSize: "20px" }} variant="subtitle2">
                Market Share Comparison
              </Typography>
              <Button
                sx={{
                  "&:hover": {
                    bgcolor: "grey.lighter",
                  },
                  mt: 2,
                  minWidth: "30px !important"
                }}
                startIcon={<CloseIcon sx={{ color: "black.main" }} />}
                onClick={handleClose}
              ></Button>
            </Box>

            <Divider sx={{ mt: 2 }} />
            <Grid container spacing={2}>
              <Grid item xs={6} lg={4} md={4} sm={4}>
                <Box sx={{ mt: 2 }}>
                  <FormControl>
                    <InputLabel id="demo-simple-select-label">
                      Time Period
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={MarketShareTimePeriod}
                      label="Country"
                      sx={{
                        height: 40,
                        width: SW,
                        color: "black.main",
                      }}
                      onChange={(event) =>
                        handleStateUpdate(event, "MarketShareTimePeriod")
                      }
                    >
                      {CBDMPeriod.map((period, index) => {
                        return (
                          <MenuItem key={index} value={period}>
                            {period}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={6} lg={4} md={4} sm={4}>
                <Box sx={{ mt: 2 }}>
                  {/* <AutoCompleteMS /> */}
                  <MultiSelectBrand getBrands={brandsByCountry} reference={selectedBrandsByCountry} />
                </Box>
              </Grid>
              <Grid item xs={6} lg={4} md={4} sm={4}>
                <Box sx={{ mt: 2 }}>
                  {/* <AutoCompleteMS /> */}
                  <MultiSelectSKU getSKUData={productGroupsForMS} reference={selectedReferenceSKU} />
                </Box>
              </Grid>

            </Grid>

            <Grid container justifyContent="flex-end">
              <Grid item>
                <Box sx={{ mt: 2, mr: 1 }}>
                  <CustomButton
                    startIcon={<SaveIcon />}
                    // sx={{
                    //   bgcolor: "darkred.light",
                    //   color: "white.main",
                    //   textTransform: "none",
                    //   "&:hover": {
                    //     bgcolor: "darkred.main",
                    //   },
                    // }}
                    onClick={handleRetrieve}
                  >
                    Retrieve
                  </CustomButton>
                </Box>
              </Grid>
            </Grid>
            <Grid style={{ paddingTop: "30px" }}>
              {marketShareComparisonList?.length > 0 && (
                <Grid container direction="column" spacing={2}>
                  {/* <Grid item sx={{ width: "100%" }}>
                            <DataGrid
                            rows={marketShareComparisonList}
                            columns={selectColumn}
                            disableRowSelectionOnClick={true}
                            disableColumnFilter={true}
                            disableColumnMenu={true}
                            checkboxSelection={false}
                            onRowSelectionModelChange={(selRows) => {
                                dispatch(setState("selectedRows", selRows));
                                if (selRows.length > 0) {
                                    // const quotaId = quotaForApprovalTable.rows[selRows[selRows.length - 1]].quotaId;
                                    // dispatch(getQuotaCustomerBreakdown({ quotaId }));
                                }
                            }}
                            rowSelectionModel={selectedRows}
                            />
                        </Grid> */}
                  <TableContainer
                    component={Paper}
                    style={{
                      padding: "30px",
                      maxHeight: "700px",
                      overflowY: "auto",
                    }}
                  >
                    <Table>
                      <TableHead
                        sx={{
                          "& th": {
                            color: "black.main",
                            backgroundColor: "grey.lighter",
                          },
                        }}
                      >
                        <TableRow>
                          <TableCell rowSpan={2}></TableCell>
                          <TableCell
                            colSpan={2}
                            style={{ textAlign: "center" }}
                          >
                            Scenario SKU
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            External Fix
                          </TableCell>
                          <TableCell
                            colSpan={2}
                            style={{ textAlign: "center" }}
                          >
                            Domestic ref SKU (Selected SKU)
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            External WHS MS(if any)
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            Manually Defined (optional)
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableHead
                        sx={{
                          "& th": {
                            color: "black.main",
                            backgroundColor: "grey.lighter",
                          },
                        }}
                      >
                        <TableRow>
                          {headers.map((header) => (
                            <TableCell
                              key={header.id}
                              onClick={() => handleRequestSort(header.id)}
                              style={{
                                cursor: "pointer",
                                textAlign:
                                  header.label === "Customers"
                                    ? "left"
                                    : "center",
                              }}
                            >
                              {header.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody style={{ textAlign: "center" }}>
                        {sortedRows?.map((row) => (
                          <TableRow key={row.id}>
                            <TableCell>{row.name}</TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              {row.scenarioSKU_Volume?.toLocaleString('en-US')}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                            {row.scenarioSKU_MS % 1 === 0
                              ? row.scenarioSKU_MS : row.scenarioSKU_MS.toFixed(1)}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                            {row.external_Fix_MS % 1 === 0
                              ? row.external_Fix_MS : row.external_Fix_MS.toFixed(1)}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                              {row.referenceSKU_Volume?.toLocaleString('en-US')}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                            {row.referenceSKU_MS % 1 === 0
                              ? row.referenceSKU_MS : row.referenceSKU_MS.toFixed(1)}
                            </TableCell>
                            <TableCell style={{ textAlign: "center" }}>
                            {row.external_MS % 1 === 0
                              ? row.external_MS : row.external_MS.toFixed(1)}
                            </TableCell>
                            <TableCell style={{ alignItems: "center" }}>
                              <input
                                type="number"
                                OnlyNumber
                                step="0.1" 
                                onChange={updateManuallyDefined(row)}
                                class="form-control form-control-sm"
                                style={{
                                  width: "80px",
                                  height: "40px",
                                  textAlign: "center",
                                }}
                                value={row.manually_Defined_MS}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                        {/* {rowsPerPage >= marketShareComparisonList.length && ( */}
                        <TableRow>
                          <TableCell>Total</TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {marketShareComparisonList.reduce(
                              (a, b) => a + Number(b.scenarioSKU_Volume),
                              0
                            ).toLocaleString('en-US')}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {marketShareComparisonList
                              .reduce((a, b) => a + Number(b.scenarioSKU_MS), 0)
                              .toFixed(0)}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {(sum => sum % 1 === 0 ? sum : Number(sum.toFixed(1)))(
                              marketShareComparisonList.reduce((a, b) => a + Number(b.external_Fix_MS), 0)
                            )}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {marketShareComparisonList.reduce(
                              (a, b) => a + Number(b.referenceSKU_Volume),
                              0
                            ).toLocaleString('en-US')}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {marketShareComparisonList
                              .reduce(
                                (a, b) => a + Number(b.referenceSKU_MS),
                                0
                              )
                              .toFixed(0)}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {(sum => sum % 1 === 0 ? sum : Number(sum.toFixed(1)))(
                              marketShareComparisonList.reduce((a, b) => a + Number(b.external_MS), 0)
                            )}
                          </TableCell>
                          <TableCell style={{ textAlign: "center" }}>
                            {(sum => sum % 1 === 0 ? sum : Number(sum.toFixed(1)))(
                              marketShareComparisonList.reduce((a, b) => a + Number(b.manually_Defined_MS), 0)
                            )}
                          </TableCell>
                        </TableRow>
                        {/* )} */}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <TablePagination
                    rowsPerPageOptions={[20, 50, 100]}
                    component="div"
                    count={marketShareComparisonList.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                  />
                </Grid>
              )}
              {marketShareComparisonList?.length > 0 && (
                <Box>
                  <Button
                    startIcon={<SaveIcon />}
                    sx={{
                      bgcolor: "darkred.light",
                      color: "white.main",
                      textTransform: "none",
                      mt: 1,
                      "&:hover": {
                        bgcolor: "darkred.main",
                      },
                    }}
                    style={{ float: "right" }}
                    disabled={!isRestrictedAccess}
                    onClick={handleSave}
                  >
                    Save
                  </Button>
                </Box>
              )}
              {marketShareComparisonList?.length > 0 && (
                <Grid
                  container
                  direction="column"
                  spacing={2}
                  style={{ paddingTop: "50px" }}
                >
                  <Grid item sx={{ width: "100%", height: "100%" }}>
                    <Paper elevation={2}>
                      <Chart
                        options={options}
                        series={series}
                        className="barChart"
                        type="bar"
                        width={drawerOpen ? "100%" : "100%"}
                        height={drawerOpen ? "700" : "750"}
                      // events= {{
                      //     legendClick:handleLegendClick,
                      //     dataPointSelection: handleBarClick
                      // }}
                      />
                    </Paper>
                    <Dialog open={openPopup} onClose={handleClosePopup}>
                      <DialogTitle style={{ fontSize: "20px" }}>
                        Market Share Comparison for {name}
                        <IconButton
                          aria-label="close"
                          onClick={handleClosePopup}
                          sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </DialogTitle>
                      <DialogContent>
                        <Chart
                          options={optionsPopup}
                          series={[popupData]}
                          type="bar"
                          width={500}
                          height={500}
                        />
                      </DialogContent>
                    </Dialog>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Box>
        </Modal>
      )}
    </Box>
  );
}
